import { combineReducers } from "redux";

import favorites from "./favorites/reducer";

export default combineReducers({
  favorites,
});
